import _ from "lodash";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import { takeLatest } from "redux-saga/effects";

import {
  defaultReturn,
  generateDefaultActions,
  makePayload,
  requestSaga
} from "../utils/helpers";

const initialState = {
  lastUpdatedGuestGroup: null,
  lastAddedGuestGroup: null,
  guestGroups: [],
  guestGroup: {}
};

// GET_GUEST_GROUP_BY_ID
export const GET_GUEST_GROUP_BY_ID = generateDefaultActions(
  "GET_GUEST_GROUP_BY_ID"
);
export const getGuestGroupById = payload => makePayload(GET_GUEST_GROUP_BY_ID.value, payload);
function* getGuestGroupByIdSaga(payload) {
  const { id } = payload;
  yield requestSaga(GET_GUEST_GROUP_BY_ID, `/guestGroup?id=${id}`);
}

// GET_ALL_GUEST_GROUPS
export const GET_ALL_GUEST_GROUPS = generateDefaultActions(
  "GET_ALL_GUEST_GROUPS"
);
export const getAllGuestGroups = payload => makePayload(GET_ALL_GUEST_GROUPS.value, payload);
function* getAllGuestGroupsSaga(payload) {
  const { includeAuxData } = payload;
  yield requestSaga(
    GET_ALL_GUEST_GROUPS,
    `/guestGroup?includeAuxData=${includeAuxData}`
  );
}

// DELETE_GUEST_GROUP_BY_ID
export const DELETE_GUEST_GROUP_BY_ID = generateDefaultActions(
  "DELETE_GUEST_GROUP_BY_ID"
);
export const deleteGuestGroupById = payload => makePayload(DELETE_GUEST_GROUP_BY_ID.value, payload);
function* deleteGuestGroupByIdSaga(payload) {
  yield requestSaga(
    DELETE_GUEST_GROUP_BY_ID,
    `/guestGroup?id=${payload.id}`,
    "DELETE"
  );
}

// CREATE_NEW_GUEST_GROUP
export const CREATE_NEW_GUEST_GROUP = generateDefaultActions(
  "CREATE_NEW_GUEST_GROUP"
);
export const createNewGuestGroup = payload => makePayload(CREATE_NEW_GUEST_GROUP.value, payload);
function* getCreateNewGuestGroupSaga(payload) {
  const url = "/addGuestGroup";
  yield requestSaga(CREATE_NEW_GUEST_GROUP, url, "POST", payload);
}

// UPDATE_GUEST_GROUP
export const UPDATE_GUEST_GROUP = generateDefaultActions("UPDATE_GUEST_GROUP");
export const updateGuestGroup = payload => makePayload(UPDATE_GUEST_GROUP.value, payload);
function* getUpdateGuestGroupSaga(payload) {
  const url = "/guestGroup";
  yield requestSaga(UPDATE_GUEST_GROUP, url, "POST", payload);
}

export default function guestGroupReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_GUEST_GROUPS.success:
      return defaultReturn(state, payload.response, "guestGroups");
    case GET_GUEST_GROUP_BY_ID.success:
      return defaultReturn(state, payload.response, "guestGroup");
    case CREATE_NEW_GUEST_GROUP.success:
      const stateWithAddedGuestGroup = defaultReturn(state, payload.result, "lastAddedGuestGroup");
      stateWithAddedGuestGroup.guestGroups = [payload.result, ...stateWithAddedGuestGroup.guestGroups];
      ToastSuccess("Guest Group Added");

      return stateWithAddedGuestGroup;
    case UPDATE_GUEST_GROUP.success:
      ToastSuccess("Guest Group Updated");

      return defaultReturn(state, payload.result, "lastUpdatedGuestGroup");
    case DELETE_GUEST_GROUP_BY_ID.success:
      const newGuestGroups = [...state.guestGroups];
      const deletedGuestGroup = newGuestGroups.filter(guestGroup => guestGroup.id === payload.id)[0];
      _.remove(newGuestGroups, deletedGuestGroup);
      const stateWithDeletedGuestGroup = defaultReturn(state, payload.response, "guestGroups");
      stateWithDeletedGuestGroup.guestGroups = newGuestGroups;

      ToastSuccess("Guest Group Deleted");

      return stateWithDeletedGuestGroup;
    case DELETE_GUEST_GROUP_BY_ID.failure:
      ToastError("Error Deleting Guest Group");
      break;
    default:
      return state;
  }
}

export function* guestGroupSaga() {
  yield takeLatest(CREATE_NEW_GUEST_GROUP.value, getCreateNewGuestGroupSaga);
  yield takeLatest(UPDATE_GUEST_GROUP.value, getUpdateGuestGroupSaga);
  yield takeLatest(GET_ALL_GUEST_GROUPS.value, getAllGuestGroupsSaga);
  yield takeLatest(GET_GUEST_GROUP_BY_ID.value, getGuestGroupByIdSaga);
  yield takeLatest(DELETE_GUEST_GROUP_BY_ID.value, deleteGuestGroupByIdSaga);
}
